import types from '../constants/propertyConstant';

export const getBuildingAction = (data) => ({
  type: types.GET_BUILDING,
  payload: data,
});

export const setBuildingAction = (data) => ({
  type: types.SET_BUILDING,
  payload: data,
});

export const setBuildingErrorAction = (message) => ({
  type: types.SET_BUILDING_ERROR,
  payload: message,
});

export const getAppAction = (data) => ({
  type: types.GET_APP,
  payload: data,
});

export const setAppAction = (data) => ({
  type: types.SET_APP,
  payload: data,
});

export const setAppErrorAction = (message) => ({
  type: types.SET_APP_ERROR,
  payload: message,
});

export const getClaimAction = (data) => ({
  type: types.GET_CLAIM,
  payload: data,
});

export const setClaimAction = (data) => ({
  type: types.SET_CLAIM,
  payload: data,
});

export const setClaimErrorAction = (message) => ({
  type: types.SET_CLAIM_ERROR,
  payload: message,
});

export const getPolicyAction = (data) => ({
  type: types.GET_POLICY,
  payload: data,
});

export const setPolicyAction = (data) => ({
  type: types.SET_POLICY,
  payload: data,
});

export const setPolicyErrorAction = (message) => ({
  type: types.SET_POLICY_ERROR,
  payload: message,
});

export const getPolicyCancelAction = (data) => ({
  type: types.GET_POLICY_CANCEL,
  payload: data,
});

export const setPolicyCancelAction = (data) => ({
  type: types.SET_POLICY_CANCEL,
  payload: data,
});

export const cancelPoliciesAction = (data) => ({
  type: types.CANCEL_POLICIES,
  payload: data,
});

export const errMsg = (msg) => ({
  type: types.SET_ERR,
  payload: msg,
});

export const getBuildingDelegationAction = (data) => ({
  type: types.GET_BUILDING_DELEGATION,
  payload: data,
});

export const setBuildingDelegationAction = (data) => ({
  type: types.SET_BUILDING_DELEGATION,
  payload: data,
});

export const getBuildingInvoiceAction = (data) => ({
  type: types.GET_BUILDING_INVOICE,
  payload: data,
});

export const setBuildingInvoiceAction = (data) => ({
  type: types.SET_BUILDING_INVOICE,
  payload: data,
});

export const setPolicyCancelLogsAction = (data) => ({
  type: types.SET_POLICY_CANCEL_LOGS,
  payload: data,
});

export const setPolicyCancelLogsErrorAction = (message) => ({
  type: types.SET_POLICY_CANCEL_LOGS_ERROR,
  payload: message,
});

export const getPolicyCancelLogsAction = (data) => ({
  type: types.GET_POLICY_CANCEL_LOGS,
  payload: data,
});

export const getPolicyDetailAction = (data) => ({
  type: types.GET_POLICY_DETAIL,
  payload: data,
});

export const setPolicyDetailAction = (data) => ({
  type: types.SET_POLICY_DETAIL,
  payload: data,
});

export const getAppDetailAction = (data) => ({
  type: types.GET_APP_DETAIL,
  payload: data,
});

export const setAppDetailAction = (data) => ({
  type: types.SET_APP_DETAIL,
  payload: data,
});

export const getClaimDetailAction = (data) => ({
  type: types.GET_CLAIM_DETAIL,
  payload: data,
});

export const setClaimDetailAction = (data) => ({
  type: types.SET_CLAIM_DETAIL,
  payload: data,
});

export const getBuildingDetailAction = (data) => ({
  type: types.GET_BUILDING_DETAIL,
  payload: data,
});

export const setBuildingDetailAction = (data) => ({
  type: types.SET_BUILDING_DETAIL,
  payload: data,
});

export const setAppDetailErrorAction = () => ({
  type: types.SET_APP_DETAIL_ERROR,
});

export const setPolicyDetailErrorAction = () => ({
  type: types.SET_POLICY_DETAIL_ERROR,
});

export const setClaimDetailErrorAction = () => ({
  type: types.SET_CLAIM_DETAIL_ERROR,
});

export const setBuildingDetailErrorAction = () => ({
  type: types.SET_BUILDING_DETAIL_ERROR,
});
